module.exports = __webpack_public_path__ + "img/fact_check.51c61f5d.svg";